// custom (equipe interna): mapeamento rota → escopo interno/externo, fonte única de verdade
// compartilhada por ChatList.vue (filtro da lista + contagem) e ConversationItem.vue
// (navegação scope-aware do card). Mantém os dois lados em sincronia: se divergirem, abrir uma
// conversa interna flipa a lista para escopo de cliente e a conversa some do contexto.
//
// 'exclude' → aba "Conversas" (só clientes) · 'only' → aba "Caixa de Entrada" (só equipe).
// Rotas neutras (label/team/folder/search) → undefined (sem filtro; idêntico ao upstream).
// Gated por dados no backend (CwCustom::ConversationFinderDecorator): sem blocklist/inbox
// interna semeada, exclude/only viram no-op.
// ⚠️ AS QUATRO ROTAS SÃO NECESSÁRIAS — medido em produção, 31/08/2026.
//
// Durante muito tempo esta lista teve só as duas primeiras, e a consequência era uma
// divergência que ninguém conseguia explicar: a caixa "Gustavo Projetos e Inovações"
// mostrava 92 conversas e "Todas as conversas" mostrava 67. Vinte e cinco de diferença —
// 16 internas e 9 em triagem — porque a tela do canal (`inbox_dashboard`) não estava aqui
// e, sem estar, não pedia filtro nenhum ao servidor.
//
// O sintoma lido de fora é o pior tipo: nada quebra, nada dá erro, e as duas telas
// simplesmente discordam sobre quais conversas existem. Quem usa conclui que a plataforma
// está perdendo mensagem.
//
// `conversation_through_inbox` entra junto pelo mesmo motivo que `inbox_conversation`
// acompanha `home`: abrir uma conversa a partir do canal não pode reabrir a lista num
// escopo diferente do que a listou.
export const CLIENT_SCOPE_ROUTES = [
  'home',
  'inbox_conversation',
  'inbox_dashboard',
  'conversation_through_inbox',
];
export const INTERNAL_SCOPE_ROUTES = [
  'crm_internal_inbox',
  'crm_internal_inbox_conversation',
];

export function internalScopeForRoute(routeName) {
  if (INTERNAL_SCOPE_ROUTES.includes(routeName)) return 'only';
  if (CLIENT_SCOPE_ROUTES.includes(routeName)) return 'exclude';
  return undefined;
}

// ── TRIAGEM (2026-08-07) ─────────────────────────────────────────────────────────────
// A fila da IA ganha aba própria, só para a administradora. Mesmo mecanismo do escopo
// interno, e mesma razão para viver aqui: o ChatList (lista + contagem) e o ConversationItem
// (navegação do card) precisam concordar. Se divergirem, abrir uma conversa da triagem
// devolve a lista para o escopo de cliente e a conversa some do contexto.
//
// As duas metades são necessárias. Só o 'only' criaria a aba e deixaria as MESMAS conversas
// duplicadas em "Conversas" — a mesma fila em dois lugares, sem dizer qual é o trabalho.
//
// ⚠️ ATUALIZAÇÃO 2026-08-09 — LEIA ANTES DE "LIMPAR" ESTE BLOCO.
//
// A aba Qualificação foi removida (virou a aba Fluxos), então as rotas abaixo NÃO EXISTEM
// mais e o ramo `'only'` ficou inalcançável. A tentação óbvia é apagar o bloco inteiro por
// ser código morto. **Não apague.**
//
// O que morreu foi só metade: o ramo `'exclude'`, que devolve 'exclude' para `home` e
// `inbox_conversation`, é o que mantém as conversas EM TRIAGEM fora da lista de Conversas
// de todo mundo. Apagar o bloco derramaria a fila da IA na caixa de cada operadora — o
// vazamento que a separação por setor existe para impedir, reintroduzido por uma faxina.
//
// A lista de rotas fica vazia de propósito, e não removida: se um dia voltar a existir uma
// tela que mostre a fila da triagem, basta acrescentar o nome dela aqui.
export const TRIAGEM_SCOPE_ROUTES = [];

export function triagemScopeForRoute(routeName) {
  if (TRIAGEM_SCOPE_ROUTES.includes(routeName)) return 'only';
  if (CLIENT_SCOPE_ROUTES.includes(routeName)) return 'exclude';
  return undefined;
}
